(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-02"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-02');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-03"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-03');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll
            this.headerHeight = this.header.clientHeight;
            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop <= this.headerHeight) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-04"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-04');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.HeaderAnnouncement = document.getElementById('shopify-section-announcement-bar').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (document.getElementById('shopify-section-announcement-bar') && this.HeaderAnnouncement > 0) {
                var headerHeight = this.header.clientHeight + this.HeaderAnnouncement
            } else {
                var headerHeight = this.header.clientHeight
            }
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (headerHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
            if(!$('.header-04').hasClass('style_3')){
                $('.vertical-menu').addClass('hide');
            }
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
            if(!$('.header-04').hasClass('style_3')){
                if ($('.vertical-menu').hasClass('open')) {
                    $('.vertical-menu').removeClass('hide');
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-05"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-05');
            this.header_1 = document.querySelector('.enable_parallax');
            if (this.header_1 != null) {
              this.heightEle = this.header_1.clientHeight;
            } else {
              this.heightEle = this.header.clientHeight;
            }
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-06"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-06');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }
        
        disconnectedCallback() {
            window.removeEventListener('resize', this.onResizeHandler);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (window.innerWidth > 1200 && document.querySelector('.layout_search--style2')) {
                    const openDetailsElement = this.querySelector('details[open]');
                    if (openDetailsElement) {
                        const summaryElement = openDetailsElement.querySelector('summary');
                        openDetailsElement.removeAttribute('open');
                        summaryElement.focus();
                        document.body.classList.remove('open_search');
                    }
                }
                if (!document.body.classList.contains('cart-sidebar-show') && 
                    !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                    }
                    this.check = true;
                    this.currentScrollTop = scrollTop;
                }
            } else {
                this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-07"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-07');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
                if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                    if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        if (this.hideOnScroll == 'true') {
                            requestAnimationFrame(this.hide.bind(this));
                        } else {
                            requestAnimationFrame(this.reveal2.bind(this));
                        }
                    } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                        requestAnimationFrame(this.reveal.bind(this));
                    } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                        requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
                }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-08"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-08');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-09"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-09');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-10"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-10');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-11"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-11');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-12"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header-12');
            this.heightEle = this.header.clientHeight;
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll
            
            this.onScrollHandler = this.onScroll.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            if (this.header_1 != null) {
                observer.observe(this.header_1);
            } else {
                observer.observe(this.header);
            }
        }

        onScroll() {
            if (this.header_1 == null || this.header_1 == '') 
              this.style.height = `${this.header.clientHeight}px`;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check || scrollTop == 0) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.heightEle) {
                  if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(-${this.header_1.clientHeight}px)`;
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.heightEle) {
                    requestAnimationFrame(this.reveal.bind(this));
                    if (this.header_1 != null) 
                      this.header_1.style.transform = `translateY(0)`;
                } else if (scrollTop - (this.heightEle - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                    if (this.header_1 != null) 
                        this.header_1.style.transform = `translateY(0)`;
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header');
            this.headerBottom = document.querySelector('.header-bottom').clientHeight;
            this.headerBounds = {}; 
            this.currentScrollTop = 0;
            this.check = false;
            this.hideOnScroll = this.dataset.hideOnScroll

            this.onScrollHandler = this.onScroll.bind(this);
            this.onResizeHandler = this.onResize.bind(this);

            window.addEventListener('scroll', this.onScrollHandler, false);
            window.addEventListener('resize', this.onResizeHandler);
            
            this.createObserver();
            this.onResizeHandler();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.onScrollHandler);
            window.removeEventListener('resize', this.onResizeHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onResize() {
            this.style.height = `${this.querySelector('header.header').clientHeight}px`;
        }
        
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (!this.check) {
              if (!document.body.classList.contains('cart-sidebar-show') && 
                  !document.body.classList.contains('sticky-search-open')) {
                if (scrollTop > this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    if (this.hideOnScroll == 'true') {
                        requestAnimationFrame(this.hide.bind(this));
                    } else {
                        requestAnimationFrame(this.reveal2.bind(this));
                    }
                } else if (scrollTop < this.currentScrollTop && scrollTop > this.header.clientHeight) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else if (scrollTop - (this.header.clientHeight - this.headerBottom) <= this.headerBounds.top) {
                    requestAnimationFrame(this.reset.bind(this));
                }
                this.check = true;
                this.currentScrollTop = scrollTop;
              }
            } else {
              this.check = false;                                                                              
            }
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
            this.closeMenuDisclosure();
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reveal2() {
            this.header.classList.add('shopify-section-header-sticky', 'animate', 'slide-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
        
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lxent-kit-septiembre"]) return;
  try {
    
/* No dependencies; selection properties share ONE inventory-tracked kit variant. */
(() => {
  // 2026-09-14 (ronda 2): reparto de mascarillas en dos familias, decision de producto de
  // Wilmer. "rubios" son las matizadoras y "color" las de fantasia. Si manana entra una
  // mascarilla nueva al catalogo hay que anadirla tambien aqui o no saldra en ningun grupo.
  const GRUPOS = {
    rubios: ['ceniza-tenue','contra-naranja','blanco-puro','11-21','10-1','perla-beige'],
    color: ['rojo','negro','naranja-intenso','rojo-violeta','chocolate']
  };
  // 2026-09-14 (ronda 5): textos del boton propio de contraentrega (mismos que usaba el de
  // Releasit en el PDP). Van aqui y no en el snippet para no volver a subir 56 KB por tres frases.
  const COD_TEXTO='Quiero Pagar al Recibir', COD_SUB='Pago Contra Entrega', COD_ESPERA='Agregando tu kit al carrito…';
  const GRUPO_ETIQUETAS = { rubios:'Para rubios', color:'De color' };
  const GRUPO_LEYENDA = '1. ¿Qué kit buscas?';
  const GRUPO_EJEMPLO = { rubios:'ceniza-tenue', color:'negro' };
  const Logic = {
    resolve(data, kind, state) {
      if (kind === 'canas') {
        const tone = data.canas.find(t => t.id === state.mask);
        return { complete: Boolean(tone), tone, key: `canas-${tone?.id || 'chocolate'}` };
      }
      const permitidas = state.group ? GRUPOS[state.group] : null;
      const mask = data.masks.find(m => m.id === state.mask && (!permitidas || permitidas.includes(m.id)));
      const tint = mask?.codes.includes(state.tint) ? data.tints[state.tint] : null;
      const allowed = tint?.kind === 'white' ? ['activador'] : ['10','20','30','40'];
      const developer = tint && allowed.includes(state.developer) ? state.developer : null;
      const suffix = tint?.kind === 'white' ? 'blanco-activador' : `negro-${developer || '20'}vol`;
      const ejemplo = GRUPO_EJEMPLO[state.group] || 'negro';
      return { mask, tint, developer, complete: Boolean(mask && tint && developer), key: `color-${mask?.id || ejemplo}-${suffix}` };
    },
    select(state, level, value) {
      if (level === 'group') return { group:value, mask:null, tint:null, developer:null };
      if (level === 'mask') return { ...state, mask:value, tint:null, developer:null };
      if (level === 'tint') return { ...state, tint:value, developer:null };
      return { ...state, developer:value };
    },
    properties(data, kind, state) {
      const r=this.resolve(data,kind,state);
      if(!r.complete) return null;
      if(kind==='canas') return { 'Tono Color Yá':r.tone.name, 'Contenido':'Champú 200 ml + tratamiento 200 ml; funda, cepillo y caja', '_kit_config':'2026-09-09.1' };
      return { 'Mascarilla Hightone':r.mask.name+' · 300 ml', 'Tinte Hypertone':r.tint.name+' · 60 ml', 'Revelador':r.tint.kind==='white'?'Activador - 120 ml':`Oxigenta ${r.developer} vol · 90 ml`, '_kit_config':'2026-09-09.1' };
    }
  };
  window.LxentKitLogic = Logic;
  if (customElements.get('lxent-kit')) return;
  class LxentKit extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return;this.initialized=true;
      this.data=JSON.parse(this.querySelector('[data-kit-catalog]').textContent);
      this.ui=JSON.parse(this.querySelector('[data-kit-ui]').textContent);
      this.kind=this.dataset.kind;this.state={group:null,mask:null,tint:null,developer:null};this.imageOK=true;
      if(this.kind==='canas')this.querySelector('.lk-gallery>.lk-note').textContent=this.ui.canas_gradual;
      this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.topePegajoso();window.addEventListener('resize',()=>this.topePegajoso(),opts);
      window.addEventListener('load',()=>this.topePegajoso(),opts);
      this.addEventListener('change',e=>{
        if(e.target.dataset.level){const level=e.target.dataset.level;this.state=Logic.select(this.state,level,e.target.value);this.paint();this.querySelector(`[data-level="${level}"]:checked`)?.focus({preventScroll:true});}
        else if(e.target.name==='quantity')this.updatePurchase();
      },opts);
      this.addEventListener('click',e=>{
        const clear=e.target.closest('[data-clear]');if(clear){this.state=Logic.select(this.state,clear.dataset.clear,null);this.paint();this.querySelector(`[data-${clear.dataset.clear==='developer'?'developer':clear.dataset.clear}-field] input`)?.focus();}
        const thumb=e.target.closest('[data-gallery-index]');if(thumb)this.showImage(Number(thumb.dataset.galleryIndex));
        // 2026-09-14 (ronda 2): antes se repetia el barrido al volver a pulsar una opcion ya
        // elegida. Se quita: si la seleccion no cambia la imagen, no debe pasar nada.
      },opts);
      this.querySelector('form').addEventListener('submit',e=>{
        e.preventDefault();
        const allowed=this.updatePurchase();
        if(!allowed){this.querySelector('[data-purchase-status]').textContent=this.ui.draft;return;}
        // Rebuild from the validated state immediately before submission.
        this.writeProperties();
        const variantInput=this.querySelector('[data-variant-input]');variantInput.value=this.dataset.variant;variantInput.disabled=false;
        this.addToCartAjax(e.target);
      },opts);
      // El boton de Releasit (Pago Contra Entrega) se inserta dentro de este mismo form y no
      // conoce nuestra validacion: lo bloqueamos si la seleccion del kit no esta completa.
      this.addEventListener('click',e=>{
        const codBtn=e.target.closest('#rsi_buy_now_button,[id^="rsi_buy_now_button"]');
        if(!codBtn)return;
        const allowed=this.updatePurchase();
        if(!allowed){
          e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
          this.querySelector('[data-purchase-status]').scrollIntoView({behavior:'smooth',block:'center'});
        }
      },{capture:true,signal:opts.signal});
      this.querySelector('[data-hero]').addEventListener('load',()=>{this.imageOK=true;this.barrido();this.updatePurchase();this.precargar();},opts);
      this.querySelector('[data-hero]').addEventListener('error',()=>{this.imageOK=false;const gh=this.querySelector('.lk-ghost');if(gh)gh.hidden=true;this.querySelector('[data-caption]').textContent=this.ui.image_error;this.updatePurchase();},opts);
      this.montarGrupo();
      this.montarContraentrega();
      this.paint();
    }
    // 2026-09-14 (ronda 2): el paso previo se monta aqui y no en la plantilla para no volver
    // a subir el snippet de 56 KB por cuatro lineas de HTML. Solo existe en el kit de color.
    montarGrupo(){
      if(this.kind!=='color')return;
      const campo=this.el('fieldset');campo.dataset.groupField='';
      campo.append(this.el('legend',GRUPO_LEYENDA));
      const caja=this.el('div',null,'lk-options');caja.dataset.groups='';
      campo.append(caja);
      const mascarillas=this.querySelector('[data-mask-field]');
      mascarillas.parentElement.insertBefore(campo,mascarillas);
    }
    // Las leyendas vienen numeradas del archivo de idioma ("1. Elige tu mascarilla"). Con el
    // paso nuevo todo corre un numero, asi que se renumeran aqui en vez de tocar locales/es.json
    // (40 KB) por cuatro palabras. En el kit de canas se devuelven tal cual.
    numerar(texto,n){return this.kind==='color'?n+'. '+String(texto||'').replace(/^\s*\d+\.\s*/,''):texto;}
    topePegajoso(){
      // 2026-09-14 (ronda 2): la cabecera revelada NO cambia de clase, se desliza con un
      // transform. Buscar .shopify-section-header-sticky dejaba --lk-top en 0 y la galeria
      // se anclaba arriba del todo, tapando la hamburguesa. Ahora seguimos su borde inferior
      // visible cuadro a cuadro: vale 0 cuando la cabecera esta fuera y su alto cuando entra,
      // asi que la galeria la acompana en vez de pisarla.
      const cabecera=document.getElementById('shopify-section-header-05');
      const medir=()=>{
        const b=cabecera?Math.max(0,Math.round(cabecera.getBoundingClientRect().bottom)):0;
        if(b!==this.tope){this.tope=b;this.style.setProperty('--lk-top',b+'px');}
      };
      medir();
      if(!this.sigueCabecera){
        this.sigueCabecera=()=>{
          if(this.cuadro)return;
          this.cuadro=requestAnimationFrame(()=>{this.cuadro=0;medir();});
        };
        window.addEventListener('scroll',this.sigueCabecera,{passive:true,signal:this.abort.signal});
      }
    }
    disconnectedCallback(){this.abort?.abort();this.obsCabecera?.disconnect();clearTimeout(this.wipeTimer);cancelAnimationFrame(this.cuadro);this.initialized=false;}
    el(tag,text,cls){const e=document.createElement(tag);if(text)e.textContent=text;if(cls)e.className=cls;return e;}
    asset(file,w){
      if(this.dataset.preview==='true')return 'media/'+file;
      return w ? file+(file.includes('?')?'&':'?')+'width='+w : file;
    }
    anchoImagen(){
      const box=this.querySelector('.lk-large');
      const w=(box&&box.clientWidth?box.clientWidth:520)*Math.min(2,window.devicePixelRatio||1);
      return Math.max(400,Math.min(1200,Math.ceil(w/100)*100));
    }
    option(level,value,label,swatch,cover){
      const l=this.el('label',null,'lk-option'),input=this.el('input');input.type='radio';input.name='kit_'+level;input.dataset.level=level;input.value=value;input.required=true;input.checked=this.state[level]===value;
      const span=this.el('span');
      if(swatch){
        input.setAttribute('aria-label',label);l.title=label;
        const frame=this.el('i',null,'lk-swatch');const im=this.el('img');im.src=this.asset(swatch,180);im.alt='';im.width=600;im.height=600;im.loading='lazy';frame.append(im);
        if(cover){const mark=this.el('i',null,'lk-marker-cover');mark.setAttribute('aria-hidden','true');for(const k of ['left','top','width','height'])mark.style[k]=cover[k]+'%';frame.append(mark);}
        span.append(frame);
      }else span.append(this.el('b',label));
      l.append(input,span);return l;
    }
    field(name,show){const f=this.querySelector(`[data-${name}-field]`);f.hidden=!show;f.disabled=!show;return f;}
    paint(){
      const r=Logic.resolve(this.data,this.kind,this.state);this.resolved=r;
      const grupos=this.querySelector('[data-groups]');
      if(grupos){grupos.replaceChildren();for(const g of ['rubios','color'])grupos.append(this.option('group',g,GRUPO_ETIQUETAS[g]));}
      if(this.kind==='color')this.field('mask',Boolean(this.state.group));
      const masks=this.querySelector('[data-masks]');masks.replaceChildren();
      this.querySelector('[data-mask-field] legend').textContent=this.kind==='color'?this.numerar(this.ui.choose_mask,2):this.ui.choose_canas;
      this.querySelector('[data-tint-field] legend').textContent=this.numerar(this.ui.choose_tint,3);
      const lista=this.kind==='color'?this.data.masks.filter(m=>!this.state.group||GRUPOS[this.state.group].includes(m.id)):this.data.canas;
      for(const m of lista)masks.append(this.option('mask',m.id,m.name));
      this.querySelector('[data-clear="mask"]').disabled=!this.state.mask;
      this.querySelector('[data-clear="mask"]').textContent=this.kind==='canas'?this.ui.clear_tint:this.ui.clear_mask;
      this.field('tint',Boolean(r.mask));this.field('developer',Boolean(r.tint));
      const tints=this.querySelector('[data-tints]');tints.replaceChildren();
      if(r.mask){for(const c of r.mask.codes){const t=this.data.tints[c];tints.append(this.option('tint',c,t.name,t.swatch,t.swatchCover));}this.querySelector('[data-tint-help]').textContent=this.ui.tint_help+' '+r.mask.name+'.';}
      this.querySelector('[data-clear="tint"]').disabled=!r.tint;
      const devs=this.querySelector('[data-developers]');devs.replaceChildren();
      if(r.tint){
        const white=r.tint.kind==='white';
        this.querySelector('[data-developer-legend]').textContent=this.numerar(white?this.ui.confirm_activator:this.ui.choose_developer,4);
        this.querySelector('[data-developer-help]').textContent=white?this.ui.activator_help:this.ui.developer_help;
        for(const v of white?['activador']:['10','20','30','40'])devs.append(this.option('developer',v,white?this.ui.activator_label:`${v} vol · 90 ml`));
      }
      this.querySelector('[data-clear="developer"]').disabled=!r.developer;
      const summary=this.kind==='canas'?(r.tone?`${this.ui.selected} ${r.tone.name}`:this.ui.select_prompt):[r.mask?.name,r.tint?.name,r.developer?(r.developer==='activador'?this.ui.activator_label:`Oxigenta ${r.developer} vol · 90 ml`):null].filter(Boolean).join(' / ');
      this.querySelector('[data-selection]').textContent=summary||this.ui.select_prompt;
      const caption=r.complete?(this.kind==='canas'?summary:`${this.ui.selected} ${summary}`):this.ui.example;
      this.gallery=[{src:this.data.images[r.key],alt:caption}];
      if(r.tint?.model)this.gallery.push({src:r.tint.model,alt:`${this.ui.model} ${r.tint.name}. ${this.ui.reference}`});
      if(r.tint?.swatch)this.gallery.push({src:r.tint.swatch,alt:`${this.ui.swatch} ${r.tint.name}. ${this.ui.reference}`});
      const thumbs=this.querySelector('[data-gallery]');thumbs.replaceChildren();
      this.gallery.forEach((g,i)=>{const b=this.el('button');b.type='button';b.dataset.galleryIndex=i;b.setAttribute('aria-label',g.alt);const im=this.el('img');im.src=this.asset(g.src,120);im.alt='';im.width=60;im.height=76;im.loading='lazy';b.append(im);thumbs.append(b);});
      this.showImage(0);this.content();this.writeProperties();this.updatePurchase();
    }
    showImage(index){
      const g=this.gallery[index];if(!g)return;
      const image=this.querySelector('[data-hero]'),src=this.asset(g.src,this.anchoImagen());
      const box=this.querySelector('.lk-large');
      let ghost=box.querySelector('.lk-ghost');
      if(!ghost){ghost=this.el('img',null,'lk-ghost');ghost.alt='';ghost.hidden=true;ghost.setAttribute('aria-hidden','true');box.prepend(ghost);}
      image.alt=g.alt;this.querySelector('[data-large-link]').href=this.asset(g.src);this.querySelector('[data-caption]').textContent=g.alt;
      this.querySelectorAll('[data-gallery-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.galleryIndex)===index)));
      const prev=image.getAttribute('src');
      const base=u=>(u||'').split(/[?&]width=/)[0];
      // 2026-09-14 (ronda 2): si la imagen no cambia no se anima. Antes se llamaba al
      // barrido igual y, como el fantasma solo se muestra cuando hay imagen nueva, el
      // recuadro se quedaba en blanco y hacia el barrido sobre nada.
      if(prev&&base(prev)===base(src)){this.precargar();return;}
      // Descargamos la imagen ANTES de cambiar el src: asi la que se ve nunca se queda en blanco.
      this.turnoImagen=(this.turnoImagen||0)+1;const turno=this.turnoImagen;
      const previa=new Image();
      const listo=new Promise((ok,fail)=>{
        previa.onload=()=>ok();previa.onerror=()=>fail();
        previa.src=src;
        if(previa.complete&&previa.naturalWidth)ok();
      });
      listo.then(()=>{
        if(turno!==this.turnoImagen)return;
        if(prev){ghost.src=prev;ghost.hidden=false;}
        image.src=src;
      }).catch(()=>{
        if(turno!==this.turnoImagen)return;
        this.imageOK=false;if(ghost)ghost.hidden=true;
        this.querySelector('[data-caption]').textContent=this.ui.image_error;this.updatePurchase();
      });
    }
    precargar(){
      if(this.dataset.preview==='true'||this.precargado)return;
      const c=navigator.connection;if(c&&(c.saveData||/(^|-)2g$/.test(c.effectiveType||'')))return;
      this.precargado=true;
      const w=this.anchoImagen(),vistos=new Set(),lista=[];
      const add=key=>{const f=this.data.images[key];if(f&&!vistos.has(f)){vistos.add(f);lista.push(this.asset(f,w));}};
      if(this.kind==='canas')for(const t of this.data.canas)add(Logic.resolve(this.data,'canas',{mask:t.id}).key);
      else for(const m of this.data.masks)add(Logic.resolve(this.data,'color',{mask:m.id,tint:null,developer:null}).key);
      const correr=()=>{for(const u of lista.slice(0,14)){const i=new Image();i.decoding='async';i.src=u;}};
      'requestIdleCallback' in window ? requestIdleCallback(correr,{timeout:2500}) : setTimeout(correr,900);
    }
    barrido(){
      const image=this.querySelector('[data-hero]'),ghost=this.querySelector('.lk-ghost');
      const cerrar=()=>{image.classList.remove('lk-wipe');if(ghost)ghost.hidden=true;};
      image.classList.remove('lk-wipe');void image.offsetWidth;image.classList.add('lk-wipe');
      image.addEventListener('animationend',cerrar,{once:true});
      clearTimeout(this.wipeTimer);
      this.wipeTimer=setTimeout(cerrar,900);
    }
    // 2026-09-14 (ronda 5): boton propio "Pago Contra Entrega" en el lugar del de Releasit.
    // Motivo: el boton de Releasit en el PDP trabaja con una foto del carrito tomada al cargar
    // la pagina y, si el kit no estaba ahi, lo agrega el mismo SIN opciones (por eso llegaban
    // pedidos sin tono, o con dos lineas: una sin opciones y otra con). No expone forma de
    // refrescar esa foto. Su boton en la PAGINA DEL CARRITO si relee el carrito real, asi que
    // este boton solo asegura el kit en el carrito con sus opciones y lleva al cliente a /cart.
    montarContraentrega(){
      if(this.querySelector('[data-cod]'))return;
      const btn=this.el('button');btn.type='button';btn.className='lk-cod';btn.dataset.cod='';
      btn.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M2.5 6.5A1.5 1.5 0 0 1 4 5h9.5A1.5 1.5 0 0 1 15 6.5V15H2.5zM15 9h3.2c.5 0 .9.2 1.2.6l2.1 2.7c.2.3.3.6.3.9V15H15zM5.75 19.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm12 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"/></svg><span><b>'+COD_TEXTO+'</b><small>'+COD_SUB+'</small></span>';
      const ancla=this.querySelector('[data-btn-skel]')||this.querySelector('form>.lk-note')||this.querySelector('.lk-purchase');
      ancla.insertAdjacentElement('afterend',btn);
      btn.addEventListener('click',()=>this.contraentrega(btn),{signal:this.abort.signal});
    }
    async contraentrega(btn){
      if(btn.disabled)return;
      const allowed=this.updatePurchase();
      const status=this.querySelector('[data-purchase-status]');
      if(!allowed){status.scrollIntoView({behavior:'smooth',block:'center'});return;}
      btn.disabled=true;btn.classList.add('loading');status.textContent=COD_ESPERA;
      try{
        this.writeProperties();
        await this.ensureInCart();
        window.location.href='/cart';
      }catch(err){
        status.textContent=(err&&err.message&&err.message!=='cart')?err.message:this.ui.stock_shared;
        btn.disabled=false;btn.classList.remove('loading');
      }
    }
    // Asegura que la configuracion ACTUAL del kit este en el carrito real con sus opciones: si ya
    // esta igual, solo iguala la cantidad; si no esta, la agrega. No quita nada mas (otro tono
    // agregado antes puede ser un regalo): el carrito y el formulario muestran todo lo que va.
    // Solo se llama desde el boton [data-cod]; nunca sola.
    async ensureInCart(){
      const p=Logic.properties(this.data,this.kind,this.state);
      if(!p)throw new Error(this.ui.required);
      const qty=Number(this.querySelector('[name="quantity"]').value)||1;
      const variante=String(this.dataset.variant);
      const mismas=(props)=>{const a=Object.keys(props||{}),b=Object.keys(p);return a.length===b.length&&b.every(k=>props[k]===p[k]);};
      const json=(r)=>{if(!r.ok)throw new Error('cart');return r.json();};
      const cambiar=(line,quantity)=>fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})}).then(json);
      const cart=await fetch('/cart.js').then(json);
      const propia=cart.items.find(it=>String(it.variant_id)===variante&&mismas(it.properties));
      if(propia){if(propia.quantity!==qty)await cambiar(cart.items.indexOf(propia)+1,qty);return;}
      const fd=new FormData();fd.append('id',variante);fd.append('quantity',qty);
      for(const [key,value] of Object.entries(p))fd.append(`properties[${key}]`,value);
      const added=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd}).then(r=>r.json());
      if(!added||added.status)throw new Error((added&&added.description)||this.ui.stock_shared);
    }
    writeProperties(){
      const box=this.querySelector('[data-properties]');box.replaceChildren();const p=Logic.properties(this.data,this.kind,this.state);
      if(p)for(const [key,value]of Object.entries(p)){const input=this.el('input');input.type='hidden';input.name=`properties[${key}]`;input.value=value;box.append(input);}
    }
    addToCartAjax(form){
      // Publicamos por fetch a /cart/add.js (el mismo endpoint nativo de Shopify) y abrimos
      // el mismo cajon lateral que usa el resto de la tienda, en vez de dejar la redireccion
      // de pagina completa que hace un <form> nativo sin JS que la intercepte.
      const buy=this.querySelector('[data-buy]');
      buy.disabled=true;buy.classList.add('loading');
      const status=this.querySelector('[data-purchase-status]');
      // Forzamos /cart/add.js (no window.routes.cart_add_url, que en este tema apunta a
      // /cart/add sin sufijo y no responde JSON) para obtener siempre una respuesta JSON.
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(r=>r.json())
        .then(added=>{
          if(added&&added.status){status.textContent=added.description||this.ui.stock_shared;return;}
          return Promise.all([fetch('/cart.js').then(r=>r.json()),fetch('/cart?view=ajax_side_cart').then(r=>r.text())]).then(([cart,html])=>{
            // El endpoint responde solo el fragmento interno (empieza en .previewCart), no
            // el contenedor #halo-cart-sidebar completo: lo inyectamos donde lo hace el propio
            // tema (ver halo.updateSidebarCart en theme.js) para heredar sus estilos y JS.
            const wrap=document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
            if(wrap)wrap.innerHTML=html;
            document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;});
            document.body.classList.add('cart-sidebar-show');
            document.dispatchEvent(new CustomEvent('cart-update',{detail:cart}));
          });
        })
        .catch(()=>{status.textContent=this.ui.stock_shared;})
        .finally(()=>{buy.classList.remove('loading');this.updatePurchase();});
    }
    updatePurchase(){
      if(!this.resolved)return false;
      const q=this.querySelector('[name="quantity"]'),stock=Number(this.dataset.stock),n=Number(q.value);
      const available=this.dataset.available==='true'&&stock>0;
      const quantityValid=Number.isInteger(n)&&n>0&&n<=stock;
      const allowed=this.dataset.sales==='true'&&this.dataset.preview!=='true'&&available&&this.resolved.complete&&Number.isInteger(n)&&n>0&&n<=stock&&this.imageOK&&Boolean(this.dataset.variant);
      const buy=this.querySelector('[data-buy]');buy.disabled=!allowed;this.querySelector('[data-variant-input]').disabled=!allowed;
      const cod=this.querySelector('[data-cod]');if(cod)cod.classList.toggle('lk-cod--off',!allowed);
      buy.textContent=!available?this.ui.sold_out:!this.resolved.complete?this.ui.complete:this.dataset.sales!=='true'?this.ui.review_only:this.ui.add;
      this.querySelector('[data-purchase-status]').textContent=!available?this.ui.sold_out:!quantityValid?this.ui.invalid_quantity:!this.resolved.complete?this.ui.required:this.dataset.sales!=='true'?this.ui.draft:!this.imageOK?this.ui.image_error:this.ui.stock_shared;
      return allowed;
    }
    content(){
      const r=this.resolved,ui=this.ui;
      const components=this.querySelector('[data-components]');components.replaceChildren();
      const add=(title,body,url)=>{const li=this.el('li'),strong=this.el('strong');if(url){const a=this.el('a',title);a.href=url;a.target='_blank';a.rel='noopener';strong.append(a);}else strong.textContent=title;li.append(strong,this.el('span',body));components.append(li);};
      let usage,precautions;
      if(this.kind==='color'){
        this.querySelector('[data-adaptive-description]').textContent=r.complete?`${ui.color_selected} ${r.mask.name} + ${r.tint.name}. ${ui.no_guarantee}`:ui.color_pending;
        let tintUrl=r.tint?.url;if(r.tint&&r.developer){const variant=r.tint.variants.find(v=>r.tint.kind==='white'||v.title.includes(r.developer));if(variant)tintUrl+='?variant='+variant.id.split('/').pop();}
        add(`${ui.tint_component} · ${r.tint?.name||ui.pending_tint} · 60 ml`,ui.tint_body,tintUrl);
        add(`Hightone · ${r.mask?.name||ui.pending_mask} · 300 ml`,ui.mask_body,r.mask?.url);
        add(!r.tint?ui.developer_pending:r.tint.kind==='white'?ui.activator_label:`Oxigenta · ${r.developer? r.developer+' vol':ui.pending_volume} · 90 ml`,!r.tint?ui.developer_pending_body:r.tint.kind==='white'?ui.activator_body:ui.oxy_body);
        add(ui.blonda1_title,ui.blonda1_body,'https://lxentprofessional.com/products/kit-blondaplex-unidosis-2-ampolletas-x15-ml');
        add(ui.blonda2_title,ui.blonda2_body,'https://lxentprofessional.com/products/kit-blondaplex-unidosis-2-ampolletas-x15-ml');
        add(ui.clear_title,ui.clear_body,'https://lxentprofessional.com/products/mascarilla-color-clear');
        usage=ui.color_usage;precautions=ui.color_precautions;
      }else{
        this.querySelector('[data-adaptive-description]').textContent=r.tone?`${ui.canas_selected} ${r.tone.name}. ${ui.canas_gradual}`:ui.canas_pending;
        add(`Champú Color Yá · ${r.tone?.name||ui.pending_tone} · 200 ml`,ui.shampoo_body,r.tone?.shampoo||'https://lxentprofessional.com/products/shampoo-cubre-canas-progresivo-color-ya');
        add(`Tratamiento Color Yá · ${r.tone?.name||ui.pending_tone} · 200 ml`,ui.treatment_body,r.tone?.treatment||'https://lxentprofessional.com/products/tratamiento-color-progresivo-para-canas-color-ya-x-200-ml');
        usage=ui.canas_usage;precautions=ui.canas_precautions;
      }
      add(ui.pillow_title,ui.pillow_body);add(ui.brush_title,ui.brush_body);add(ui.box_title,ui.box_body);
      const list=(selector,items)=>{const node=this.querySelector(selector);node.replaceChildren();const ol=this.el('ol');for(const text of items)ol.append(this.el('li',text));node.append(ol);};
      list('[data-usage]',usage);list('[data-precautions]',precautions);
    }
  }
  customElements.define('lxent-kit',LxentKit);
})();


  } catch(e) { console.error(e); }
})();
})();
